const ROLE_CONTENT_PREFIX = 'role:';

export function parseAssignIdentityRoleIds(
  contents: readonly string[],
): string[] {
  const roleIds: string[] = [];

  for (const item of contents) {
    if (item.startsWith(ROLE_CONTENT_PREFIX)) {
      roleIds.push(item.slice(ROLE_CONTENT_PREFIX.length));
    }
  }

  return [...new Set(roleIds)];
}
